import {Checkbox} from '@components/commons/checkbox/ChekBox.tsx'
import {Dispatch, SetStateAction} from 'react'

interface SelectRowCheckboxProps<T extends {id: string}> {
    className?: string
    isSelectAll: boolean
    setSelectedIds: Dispatch<SetStateAction<string[]>>
    setUnselectedIds: Dispatch<SetStateAction<string[]>>
    dataItem: T
    getIsRowSelected: (args: {dataItem: T}) => boolean
}
export const SelectRowCheckbox = <T extends {id: string}>({
    className,
    isSelectAll,
    setSelectedIds,
    setUnselectedIds,
    dataItem,
    getIsRowSelected
}: SelectRowCheckboxProps<T>) => {
    return (
        <Checkbox
            id="select-row"
            className={className}
            onClick={event => event.stopPropagation()}
            checked={getIsRowSelected({dataItem})}
            onChange={event => {
                const isChecked = event.target.checked
                if (isSelectAll) {
                    isChecked
                        ? setUnselectedIds(prevState => prevState.filter(id => id != dataItem.id))
                        : setUnselectedIds(prevState => [...prevState, dataItem.id])
                } else {
                    isChecked
                        ? setSelectedIds(prevState => [...prevState, dataItem.id])
                        : setSelectedIds(prevState => prevState.filter(id => id != dataItem.id))
                }
            }}
        />
    )
}
